export const application = {
  'backToClientTypes': 'Back to Client Types',
  'back': 'Back',
  'applicationForm': 'Application Form',
  'completeApplication': 'Complete Application',
  'generatedApplicationForm': 'Generated Application Form',
  'smartPreFill': 'Smart Pre-Fill',
  'smartPreFillResults': 'Smart Pre-Fill Results',
  'automaticallyCompleted': 'Automatically completed',
  'ofYourForm': 'of your form',
  'preFilled': 'Pre-filled',
  'directMatches': 'Direct matches',
  'aiGenerated': 'AI generated',
  'totalFields': 'Total fields',
  'application.title': 'Subsidy Application',
  'application.subtitle': 'Complete the form to apply for this subsidy',
  'application.confirmationMessage': 'Your application has been received',
  'application.section1': 'Farm Identity',
  'application.section2': 'Production',
  'application.section3': 'Financials',
  'application.section4': 'Technology',
  'application.section5': 'Strategic Goals',
  'application.section6': 'Additional Documents',
  'application.formSaved': 'Your application draft has been saved.',
  'application.prepareTitle': 'Prepare Your Subsidy Application',
  'application.prepareSubtitle': 'Let\'s prepare all the documents you need before going to the official EU portal.',
  'application.documentChecklist': 'Document Checklist',
  'application.docsReady': 'of ready',
  'application.officialDocument': 'Official document',
  'application.applicationForm': 'Application form',
  'application.ready': 'Ready',
  'application.prepComplete': 'Application Preparation Complete',
  'application.prepCompleteMessage': 'All required documents are ready. You can now proceed to the official EU portal to submit your application.',
  'application.platformSummary': 'Platform Action Summary',
  'application.docsVerified': 'Documents uploaded and verified',
  'application.formsAutofilled': 'Forms auto-filled with farm data',
  'application.previewGenerated': 'Application preview generated',
  'application.downloadDocs': 'Download Completed Documents',
  'application.readyToApply': 'Ready to Apply',
  'application.readyToApplyMessage': 'You\'ve prepared all necessary documents. Click below to go to the official subsidy portal.',
  'application.extensionHelp': 'The AgriTool Chrome Extension will automatically help you fill out the EU application form when you visit the site.',
} as const;